import { useSafeLocalStorage } from 'src/hooks/use-storage';

export function useIsCypress() {
  const safeLocalStorage = useSafeLocalStorage();
  return safeLocalStorage.getItem('PRISMA_CYPRESS_TEST') === 'true';
}
